import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './UserProfileView.scss';
import { useMutation, useQuery } from '@apollo/client';
import PROFILE from 'api/queries/PROFILE';
import env from 'utils/env';
import FileInput from 'components/common/FileInput';
import { withAttachments } from 'utils/graphql';
import UPDATE_USER_AVATAR from 'api/mutations/UPDATE_USER_AVATAR';
import useModalVisibility from 'components/common/hooks/useModalVisibility';
import UploadIcon from 'images/icons/upload.svg';
import StaticImageIcon from 'images/icons/static-image.png';
import CloseIcon from 'images/icons/xmark.svg';
import Clickable from '../../components/common/Clickable';
const UserProfileView = () => {
    var _a;
    const { t } = useTranslation();
    const { data, loading } = useQuery(PROFILE);
    const [avatarSrc, setAvatarSrc] = useState('');
    const [profile, setProfile] = useState(null);
    const handleAvatarError = () => setAvatarSrc(StaticImageIcon);
    const [updateAvatar] = useMutation(UPDATE_USER_AVATAR);
    useEffect(() => {
        if (!loading) {
            const userProfileStr = localStorage.getItem('userProfile');
            if (userProfileStr)
                setProfile(JSON.parse(userProfileStr));
            if (data === null || data === void 0 ? void 0 : data.me.avatar)
                setAvatarSrc(`${env.static}/${data.me.avatar}`);
        }
    }, [data === null || data === void 0 ? void 0 : data.me.avatar, loading]);
    const handleAvatarUpdate = useCallback((chosenFile) => {
        var _a;
        withAttachments(updateAvatar)({
            variables: { avatar: chosenFile ? chosenFile[0] : '', userId: (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.id },
            refetchQueries: [{ query: PROFILE }],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }).then((res) => {
            setAvatarSrc(`${env.static}/${res.data.updateUser.user.avatar}`);
            localStorage.setItem('userAvatarSrc', `${env.static}/${res.data.updateUser.user.avatar}`);
        });
    }, [(_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.id, updateAvatar]);
    const [isOpen, showPopover, hidePopover] = useModalVisibility(false);
    if (loading)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "user-profile__container" },
        React.createElement("div", { className: "user-profile__section" },
            React.createElement("div", { className: "user-profile__header" }, t('avatar')),
            React.createElement("div", { className: "user-profile__description" },
                React.createElement(FileInput, { allowedExtensions: ['jpg', 'png', 'jpeg'], allowMultipleFiles: true, onSelect: handleAvatarUpdate, disabled: false }, (openFileChooser) => (React.createElement("div", { className: "profile-avatar__container" },
                    React.createElement("div", { className: "profile-avatar__imageContainer", onMouseEnter: showPopover, onMouseMove: showPopover, onMouseLeave: hidePopover },
                        React.createElement("img", { src: avatarSrc, onError: handleAvatarError, alt: "Avatar", className: "profile-avatar__image" }),
                        isOpen && (React.createElement(Clickable, { type: "div", className: "profile-avatar__clickableContainer", disabled: false, onClick: () => avatarSrc === StaticImageIcon ? openFileChooser() : handleAvatarUpdate(null) },
                            React.createElement("div", { className: "profile-avatar__changeIcon" }, avatarSrc === StaticImageIcon ? React.createElement(UploadIcon, null) : React.createElement(CloseIcon, null)))))))))),
        React.createElement("div", { className: "user-profile__section" },
            React.createElement("div", { className: "user-profile__header" }, t('basic_info')),
            React.createElement("div", { className: "user-profile__description" },
                React.createElement("p", null,
                    React.createElement("span", null,
                        t('username'),
                        ":"),
                    React.createElement("span", null, profile === null || profile === void 0 ? void 0 : profile.username)),
                React.createElement("p", null,
                    React.createElement("span", null,
                        t('email'),
                        ":"),
                    React.createElement("span", null, profile === null || profile === void 0 ? void 0 : profile.email)),
                React.createElement("p", null,
                    React.createElement("span", null,
                        t('firstName'),
                        ":"),
                    React.createElement("span", null, profile === null || profile === void 0 ? void 0 : profile.firstName)),
                React.createElement("p", null,
                    React.createElement("span", null,
                        t('lastName'),
                        ":"),
                    React.createElement("span", null, profile === null || profile === void 0 ? void 0 : profile.lastName))))));
};
export default memo(UserProfileView);
